module.exports = __webpack_public_path__ + "img/inaccessible@1.5x.d049c225.png";